export const COLOR_SCHEME = {
  keyColor: '#ff5f40',
  // second: '#00ff00',
  // gradStart: '#537fe4',
  // gradEnd: '#5beae8',
  baseBg: '#fed04d', // ヘッダ用のBGとして使用(指定がない場合はgradStart,gradEndを使用し標準パラメータでグラデーションを描画)
}

export const YOUTUBE_LIST = [
  {
    imgsrc: '/static/img/mark_lp/houen/youtubethum_1.png',
    linkurl: 'https://youtu.be/FpBzRDgOGuM'
  },
  {
    imgsrc: '/static/img/mark_lp/houen/youtubethum_2.png',
    linkurl: 'https://youtu.be/2nMR9d5NGmc'
  },
  {
    imgsrc: '/static/img/mark_lp/houen/youtubethum_5.png',
    linkurl: 'https://youtu.be/vvQE8qrsA70'
  }
]



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/MarkLp/Houen/Lp1/basicInfos.js